export default {
  title: 'Modyfikatory',
  master_title: 'Tryb marki - Modyfikatory',
  products_creation_disabled:
    'Ze względu na aktywną integrację z {{integration}} tworzenie nowych produktów jest niedozwolone. Aby zmienić menu, wprowadź zmiany w {{integration}} i zsynchronizuj menu.',
  labels: {
    select_all: 'Zaznacz wszystkie',
  },
  buttons: {
    add_modifier: 'Dodaj modyfikator',
    delete_selected: 'Usuń zaznaczone',
    refresh: 'Odśwież',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
